import React, { ComponentProps } from "react";
import { allRatings } from "../../CustomerReviewHelper";
import { FilteredBy } from "../../reviewModels";
import {
  clearGa4EventInDataLayer,
  sendGtmEvent,
} from "~/analytics/definitions";

type RatingsFilterProps = ComponentProps<"div"> & {
  onRatingChange: (filteredBy: FilteredBy, gtmLabel?: string) => void;
  filteredBy: FilteredBy;
};

const RatingsFilter = ({
  onRatingChange,
  filteredBy,
  className,
}: RatingsFilterProps) => {
  const ratingChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const target = event.target;
    const text = target.options[target.selectedIndex]?.text;
    clearGa4EventInDataLayer();
    sendGtmEvent({
      event: "ga4_event",
      eventName: "Customer Reviews - Filter By Rating Dropdown Change",
      eventLabel: `Filter By: Rating - ${text ?? ""}`,
    });
    onRatingChange({ ...filteredBy, rating: target.value });
  };

  return (
    <div
      className={`float-left mt-[7px] xs:mt-0 px-4 xs:px-0 w-full xs:w-auto box-border ${className}`}
    >
      <label
        className="review-aggregation__label block"
        htmlFor="filterByRating"
      >
        Filter By Rating
      </label>
      <select
        className="suffix_dropdown configure item_number text-sm w-full xs:w-36 md:w-44 lg:w-[195px]"
        id="filterByRating"
        name="FilterByRating"
        onChange={ratingChangeHandler}
        data-testid="review-rating-filter-dropdown"
        value={filteredBy.rating}
      >
        <option value={allRatings}>All Ratings</option>
        <option value="5">5 Stars</option>
        <option value="4">4 Stars</option>
        <option value="3">3 Stars</option>
        <option value="2">2 Stars</option>
        <option value="1">1 Star</option>
      </select>
    </div>
  );
};

export default RatingsFilter;
